import Box from '@mui/material/Box';

function BaseDivider() {
  const BaseDividerStyle = {
  //  //  Change the color of the line
  //   '&.MuiDivider-root': { 
  //     '&:before': {
  //         borderTop: '1px solid rgba(178, 235, 177, 0.4)', 
  //     }, 
  //     '&:after': {
  //         borderTop: '1px solid rgba(178, 235, 177, 0.4)', 
  //     }, 
  // },
    borderLeft: '2px solid rgba(255,255,255,0.1)',
    my: 0.5,
};

  return (
    <Box sx={BaseDividerStyle} />
  );
}

export default BaseDivider;
